// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AlertdialogController from "./alertdialog_controller"
application.register("alertdialog", AlertdialogController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import BsController from "./bs_controller"
application.register("bs", BsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import EmailController from "./email_controller"
application.register("email", EmailController)

import EmailTagController from "./email_tag_controller"
application.register("email-tag", EmailTagController)

import EmailToolbarController from "./email_toolbar_controller"
application.register("email-toolbar", EmailToolbarController)

import FancyboxController from "./fancybox_controller"
application.register("fancybox", FancyboxController)

import FileGroupController from "./file_group_controller"
application.register("file-group", FileGroupController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import GlobalsearchController from "./globalsearch_controller"
application.register("globalsearch", GlobalsearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LayoutController from "./layout_controller"
application.register("layout", LayoutController)

import LoadingBarController from "./loading_bar_controller"
application.register("loading-bar", LoadingBarController)

import MediaCaptureController from "./media_capture_controller"
application.register("media-capture", MediaCaptureController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PatrolController from "./patrol_controller"
application.register("patrol", PatrolController)

import PersonGroupController from "./person_group_controller"
application.register("person-group", PersonGroupController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PostcodeController from "./postcode_controller"
application.register("postcode", PostcodeController)

import PulltorefreshController from "./pulltorefresh_controller"
application.register("pulltorefresh", PulltorefreshController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import SecurityServicesPatrolsRoadController from "./security_services_patrols_road_controller"
application.register("security-services-patrols-road", SecurityServicesPatrolsRoadController)

import TableController from "./table_controller"
application.register("table", TableController)

import TaskController from "./task_controller"
application.register("task", TaskController)

import TaskFormController from "./task_form_controller"
application.register("task-form", TaskFormController)

import TaskPeopleController from "./task_people_controller"
application.register("task-people", TaskPeopleController)

import TaskPersonGroupsController from "./task_person_groups_controller"
application.register("task-person-groups", TaskPersonGroupsController)

import TaskScheduleController from "./task_schedule_controller"
application.register("task-schedule", TaskScheduleController)

import TaskTagController from "./task_tag_controller"
application.register("task-tag", TaskTagController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import WebpushController from "./webpush_controller"
application.register("webpush", WebpushController)
